import React from 'react'
import PropTypes from 'prop-types'
import {Box, Flex, Heading, Img, Link, useMultiStyleConfig} from '@chakra-ui/react'
import useDamImage from '../../../custom-hooks/use-dam-image'
import {useGetCategoriesData} from '../../../custom-api/hooks/use-get-categories-data'
import {getGlobalLink} from '../../../utils/contentstack-utils'
import {remCalc} from '../../../theme/_utils'
import SanitizedHtml from '../../html-sanitizer'
import useMultiSite from '@salesforce/retail-react-app/app/hooks/use-multi-site'
import {useProducts} from '@salesforce/commerce-sdk-react'

export const Disclaimer = ({
    bodycopy,
    heading = '',
    icon,
    links = [],
    maxWidth = remCalc(1920),
}) => {
    const styles = useMultiStyleConfig('Disclaimer')

    const damImage = useDamImage(icon)

    const categoriesData = useGetCategoriesData()

    const ids = links
        .filter((l) => l.button?.productsfcc?.data?.length > 0)
        .map((l) => l.button.productsfcc.data[0].id)

    const {data: productsData} = useProducts(
        {
            parameters: {
                ids: ids.join(','),
                expand: ['availability', 'images'],
            },
            headers: {
                'x-debug': 'disclaimer-index',
            },
        },
        {
            enabled: ids?.length > 0,
        },
    )
    const {locale} = useMultiSite()
    const renderedLinks =
        links?.length === 0
            ? []
            : links?.map((link, index) => {
                  const {url, label, isAbsolute} = getGlobalLink({
                      link,
                      categoriesData,
                      productsData,
                      locale: locale?.alias || locale?.id?.toLowerCase(),
                  })
                  return (
                      <Link
                          key={`disclaimer-link-${index}`}
                          href={url}
                          isExternal={isAbsolute}
                          {...styles.anchor}
                      >
                          {label}
                      </Link>
                  )
              })

    return (
        <Box {...styles.container} maxW={maxWidth}>
            <Flex {...styles.grid} direction={{lg: 'row', base: 'column'}}>
                {damImage.url && (
                    <Box {...styles.icon}>
                        <Img src={damImage.url} alt={icon?.alt || ''}></Img>
                    </Box>
                )}
                <Flex {...styles.content}>
                    {heading && (
                        <Heading as="h2" {...styles.heading}>
                            {heading}
                        </Heading>
                    )}
                    <SanitizedHtml
                        as={Box}
                        html={bodycopy}
                        data-testid="disclaimer-bodycopy"
                        {...styles.bodycopy}
                    />
                    {renderedLinks.length > 0 && <Flex {...styles.links}>{renderedLinks}</Flex>}
                </Flex>
            </Flex>
        </Box>
    )
}

Disclaimer.propTypes = {
    heading: PropTypes.string,
    bodycopy: PropTypes.string,
    icon: PropTypes.shape(),
    links: PropTypes.arrayOf(PropTypes.shape()),
    maxWidth: PropTypes.string,
}
